import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

/**
 * Which record a set of shares lives on. Applications and Screening both
 * store their Division/Team tagging on the Mandate (a screening record is a
 * "Checks" mandate); Monitoring and Profiles have their own records.
 */
export type ShareableRecord = "profile" | "mandate" | "monitoring";

const RECORD_PATH: Record<ShareableRecord, string> = {
  profile: "individual/profile",
  mandate: "individual/mandate",
  monitoring: "individual/monitoring",
};

export type UpdateRecordSharesParams = {
  record: ShareableRecord;
  recordId: number;
  /** Full replacement lists — the API takes the whole set, not a delta. */
  additional_divisions: number[];
  additional_teams: number[];
};

export const useUpdateRecordShares = () => {
  const { authHeader } = useAuth();

  return useMutation(
    ({ record, recordId, ...shares }: UpdateRecordSharesParams) =>
      axios.patch(
        `${env.verifyServiceUrl}${RECORD_PATH[record]}/${recordId}/`,
        shares,
        { headers: { Authorization: authHeader } },
      ),
  );
};
